import { FleekError } from './FleekError';

type DnsConfigNotFoundErrorOptions = {
  name: string;
};

export class DnsConfigNotFoundError extends FleekError<DnsConfigNotFoundErrorOptions> {
  public name = 'DnsConfigNotFoundError';

  toString = () => `DNS config for the "${this.data.name}" name doesn't exist.`;
}
